<!--<div class="form-group col-md-12 col-xs-12 margin-bottom-5px" *ngIf=" (mode !== 'view' && mode !== 'view2') || mode=='mode'">
  <div class="row row-for-levels">
    <div class="col-md-3 text-align-left label-padding-left-10px">
      <label for="firstName" class="margin-bottom-0px margin-top-5px label-color"> {{field.Title}}</label>
    </div>
    <div class="col-md-4 label-padding-top-2px">

      <input class="form-control " [(ngModel)]="field.Value" type="text" [ngModelOptions]="{standalone: true}" />



    </div>

  </div>

</div>-->
<div class="form-group col-md-12 col-xs-12 margin-bottom-5px" *ngIf="mode=='view'">
  <div class="row row-for-levels">
    <div class="col-md-4 text-align-left label-padding-left-10px">
      <label for="firstName" class="margin-bottom-0px margin-top-5px label-color"> {{field.Title}}</label>
    </div>
    <!--<div class="col-md-1 font-weight-bold margin-top-5px padding-left-0px">:</div>-->
    <div class="col-md-4 label-padding-top-2px">
      <label class="margin-bottom-0px margin-top-5px font-weight-normal"> {{field.Value}}</label>

    </div>

  </div>

</div>
<div class="form-group col-md-12 col-xs-12 margin-bottom-5px" *ngIf=" (mode !== 'view' && mode !== 'view2') || mode=='mode'">
  <!--<div class="form-group col-md-12 col-xs-12 margin-bottom-5px">-->
  <div class="row row-for-levels">
    <div class="col-md-3 text-align-left">
      <label for="diaplayName" class="margin-bottom-0px margin-top-5px"><span>*</span> {{field.Title}}</label>
    </div>
    <!--<div class="col-md-3 text-align-left">
      <label for="valuesourcename" class="margin-bottom-0px margin-top-5px"><span>*</span> {{field.ValueSource}}</label>
    </div>-->

    <div class="col-md-4">
      <select *ngIf="Data" class="form-control" name="value" [(ngModel)]="field.Value">
        <option value="select from list.."> </option>
        <option *ngFor="let R of Data.ValueSourceList" [value]="R"
                [selected]="R ===  field.Value ">
          {{R}}
        </option>

      </select>
      <!--
                   (change)="onChange($event.target.value)"
          <CodeTypeValue [CodeType]="field.ValueSource"
                     id="CurrentActorAddEmergencyInfoRequest.RelationType"
                     [(ngModel)]="field.Value" SelectedValue="field.Value"
                     name="field.Value">
      </CodeTypeValue>-->


    </div>
  </div>


</div>

<div class="form-group col-md-12 col-xs-12 margin-bottom-5px" *ngIf="mode=='view2'">
  <div class="row row-for-levels font-size-14">
    <div class="col-md-5 text-align-left label-padding-left-10px">
      <label for="firstName" class="margin-bottom-0px margin-top-5px label-color"> {{field.Title}}</label>
    </div>
    <!--<div class="col-md-1 font-weight-bold margin-top-5px padding-left-0px">:</div>-->
    <div class="col-md-5 label-padding-top-2px">
      <label class="margin-bottom-0px margin-top-5px font-weight-normal"> {{field.Value}}</label>

    </div>

  </div>

</div>


<!--<div class="form-group col-md-12 col-xs-12 margin-bottom-5px" *ngIf="FormMode=='View'">
  <div class="row">
    <div class="col-md-3 text-align-right">
      <label for="diaplayName"><span>*</span> {{field.Title}}</label>
    </div>

    <div class="col-md-4">
      <label for="diaplayName"><span>*</span> {{field.Value}}</label>


    </div>
  </div>


</div>-->
